import { Colors } from '../../../config/theme';
import styled from 'styled-components';

export const FilterBtnsStyled = styled.div`
  padding: 0 0rem 0.5rem 1rem;
  display: flex;
  align-items: center;
  grid-gap: 10px;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  color: #4c6870;

  .css-1u9des2-indicatorSeparator {
    display: none;
  }

  .css-1jqq78o-placeholder {
    color: var(--secondary-color);
  }

  .filter {
    width: 100%;
  }
`;

export const TransactionStatusTagStyled = styled.div`
  border-radius: 8px;
  padding: 2px;
  font-size: 12px;
  .status-pending {
    background: ${Colors.brightOrange};
    color: #fff;
  }
  .status-cancelled {
    background: ${Colors.brightRed};
    color: #fff;
  }
  .status-completed {
    background: ${Colors.greenMain};
    color: #fff;
  }
`;
